export type SoapConfirmationKind =
  | 'finalized'
  | 'pending_supervision'
  | 'pending_signatures'
  | 'failed';

export function interpretSoapSigningResponses(input: {
  guardianOk: boolean;
  clinicianOk: boolean;
  clinicianStatus?: string | null;
  isSlpa: boolean;
}): { canShowSuccess: boolean; status: string; kind: SoapConfirmationKind } {
  if (!input.guardianOk || !input.clinicianOk) {
    return { canShowSuccess: false, status: 'FAILED', kind: 'failed' };
  }

  const raw = String(input.clinicianStatus || '').trim();
  if (raw === 'FINALIZED') {
    return { canShowSuccess: true, status: raw, kind: 'finalized' };
  }
  if (raw === 'PENDING_SUPERVISION') {
    return { canShowSuccess: true, status: raw, kind: 'pending_supervision' };
  }
  return {
    canShowSuccess: true,
    status: raw || 'PENDING_SIGNATURES',
    kind: 'pending_signatures'
  };
}

export function soapConfirmationMessage(kind: SoapConfirmationKind): string {
  if (kind === 'finalized') {
    return 'Clinical document signed and finalized. Billing readiness evaluated.';
  }
  if (kind === 'pending_supervision') {
    return 'Your note has been signed and sent to the supervising clinician for review. Awaiting co-signature.';
  }
  if (kind === 'pending_signatures') {
    return 'Session note saved. It is not finalized. A required signature step is still outstanding.';
  }
  return 'Session note was not completed.';
}

export function resolveSavedServiceTreatingClinician(service: {
  provider_name?: unknown;
  providerName?: unknown;
} | null | undefined): string {
  const name = String(service?.provider_name || service?.providerName || '').trim();
  return name;
}

export function formatPartialSoapSaveError(
  message: string,
  docId?: string | null,
  serviceId?: string | null
): string {
  const parts = [message || 'Session note could not be completed.'];
  if (docId) parts.push(`Saved document: ${docId}.`);
  if (serviceId) parts.push(`Service: ${serviceId}.`);
  return parts.join(' ');
}
